import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const transportTypeApiSchema = v.object({
  codeDesc: v.string(),
  codeId: v.optional(v.string()),
  id: v.number(),
  lookupCodeType: v.string(),
});

export const transportTypeSchema = v.object({
  ...transportTypeApiSchema.entries,
  ...optionSchema.entries,
});

export const transportTypesApiSchema = paginatedSchema(transportTypeApiSchema);

export type TransportTypeApi = v.InferOutput<typeof transportTypeApiSchema>;
export type TransportTypesApi = v.InferOutput<typeof transportTypesApiSchema>;

export type TransportTypeFilters = Filters<TransportTypeApi>;

export type TransportTypeFiltersUpdateApi = FiltersUpdateApi<TransportTypeApi>;

export type TransportType = Prettify<Option<v.InferOutput<typeof transportTypeSchema>>>;

export type TransportTypes = Entities<TransportType>;
